import api from './axios';

export const FilesService = {
  async downloadEImza(): Promise<void> {
    await downloadFile('api/Files/eimza', 'e-imza.msi');
  },
  async downloadApk(): Promise<void> {
    await downloadFile('api/Files/apk', 'kalden.apk');
  },
};

async function downloadFile(path: string, fallbackFilename?: string): Promise<void> {
  const response = await api.get(path, { responseType: 'blob' as const });

  const disposition = (response.headers?.['content-disposition'] as string) || '';
  const contentType = ((response.headers?.['content-type'] as string) || '').toLowerCase();
  const match = disposition.match(/filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i);
  let filename = match?.[1] || match?.[2] || '';
  try {
    if (filename) filename = decodeURIComponent(filename);
  } catch (_) {}

  if (!filename) {
    filename = fallbackFilename || inferFilenameFrom(path, contentType);
  }

  const blob = response.data as Blob;
  const downloadUrl = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = downloadUrl;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.URL.revokeObjectURL(downloadUrl);
}

function inferFilenameFrom(path: string, contentType: string): string {
  const lowerPath = path.toLowerCase();
  if (lowerPath.includes('msi') || contentType.includes('msi') || contentType.includes('x-msi')) {
    return 'setup.msi';
  }
  if (lowerPath.includes('apk') || contentType.includes('android')) return 'app.apk';
  if (lowerPath.includes('eimza') || contentType.includes('application/x-msdownload'))
    return 'setup.exe';
  if (contentType.includes('zip')) return 'download.zip';
  if (contentType.includes('pdf')) return 'download.pdf';
  if (contentType.includes('json')) return 'download.json';
  return 'download.bin';
}

export default FilesService;
